import classNames from 'classnames';
import {observer} from 'mobx-react';
import styles from './style.module.scss';
import Image from 'next/image';

interface Props {
  fullPage?: boolean;
}

export const MainLoader = observer(({fullPage}: Props) => {
  return <div className={classNames(styles.masterLoaderWrapper, fullPage && styles.isFullPageMasterLoader)}>
    <Image
      src='/img/mainLoader.gif'
      width={93}
      height={150}
      style={{margin: 'auto'}}
      alt='Error image load issue'
    />
  </div>;
});
